var _defs, _circle, _path, _path2, _path3, _path4, _ellipse, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWetFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAE6FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "can",
    x1: 15,
    x2: 37,
    y1: 18,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pouch",
    x1: 34,
    x2: 51,
    y1: 11,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pouch)",
    d: "M35 12h15l3 38H32l3-38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBEAFE",
    d: "M37 21h12v13H37z",
    opacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D4ED8",
    d: "M37 12h13v7H37z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#can)",
    d: "M13 21c0-3 6-5 13-5s13 2 13 5v27c0 3-6 5-13 5s-13-2-13-5V21Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 21,
    fill: "#FCA5A5",
    rx: 13,
    ry: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C7",
    d: "M18 31h16v11H18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB923C",
    d: "M21 36c0-3 2-5 5-5s5 2 5 5-2 5-5 5-5-2-5-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWetFood);
export default __webpack_public_path__ + "static/media/wet-food.6b42991a1e4f19a74fa304a417c85873.svg";
export { ForwardRef as ReactComponent };